// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__3Tg3j","content":"RecentSearches_content__1rdVM"};